import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  components: {
    HomeNavBar
  },
  computed: {
  active_membership_plans() {
    return this.membershipPlans.filter(plan => plan.is_active)
  }
},
  mounted() {
    this.fetch_memberships();
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filter_membership_payment_history();
  },
  data() {
    return ({
      user: this.getUserData(),
      currentStepIndex: 0,
      token_exists: false,
      steps: [
        { label: 'Membership' },
        { label: 'Payment' },
      ],
      selectedPlan: '', // Default to Professional plan
      membershipPlans: [],
      current_membership: null,
      payfast: process.env.VUE_APP_PAYFAST_URL
    });
  },
  methods: {
    getUserData() {
      let user = {
        first_name: '',
        last_name: '',
        email: '',
        gender_id: '',
        date_of_birth: '',
        phone_number: '',
        user_id: '',
        newSkill: ''
      }
      return user;
    },
    getToken() {
      return get_token();
    },
    selectPlan(index) {
      this.selectedPlan = index;
    },
    selectPaymentMethod(index) {
      this.selectedPaymentMethod = index;
    },
    nextStep() {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex++;
      }
    },
    prevStep() {
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
      }
    },
    cancel() {
      // Navigate back to customer profile page
      this.$router.push('/profile');
    },
    completePayment() {
      if (this.selectedPlan === null) {
        Swal.fire({
          title: 'Please select a plan before proceeding.',
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }
      const membership_id = this.membershipPlans[this.selectedPlan].id;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_payfast_membership_payment/`,
        method: 'POST',
        data: JSON.stringify({
          membership_id: membership_id,
        }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.success) {
            var data_array = response.data_array;
            var form = $('#payment_form');
            for (var [key, value] of Object.entries(data_array)) {
              var input = $('#input_clone').clone();
              input.attr('name', key);
              input.attr('value', value);  // Accessing value without square brackets
              input.removeAttr('id');
              input.removeClass('d-none');
              form.append(input);
            }
            Swal.fire({
              title: 'Success',
              icon: 'success',
              text: "Redirecting to PayFast in a few seconds don't close this page",
              confirmButtonText: 'Ok',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            })
            form.submit();
          }
        },
        error: (error) => {
          console.error('AJAX error:', error);
          Swal.fire({
            title: 'Error',
            text: 'Payment failed. Please try again later.',
            icon: 'error',
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
        }
      });
    },

    fetch_memberships() {
      this.token_exists = get_token();

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
        method: "POST",
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {},
        success: (response) => {
          this.membershipPlans = response.data.memberships;


        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {

        this.user.user_id = this.user_details.user_id;
      }

      const payload = {
        filter_values: {
          user_id: this.user.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.current_membership = this.membership_payment_history.find(
            (payment) => payment.payment_status?.status === "paid"
          )?.membership || null;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );

          this.is_active = this.membership_payment_history[0]?.is_active || false;
          this.membership_payment_history_id = this.membership_payment_history[0]?.id || null;
          this.membership_name = this.membership_payment_history[0]?.membership?.name || '';
          this.membership_type = this.membership_payment_history[0]?.membership?.membership_type.name || '';
          this.billing_cycle = this.membership_payment_history[0]?.membership?.billing_cycle?.name || '';
          this.membership_price = this.membership_payment_history[0]?.membership?.membership_pricing[0]?.price || 0;
          this.renewal_date = this.membership_payment_history[0]?.valid_until || null;
        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },
  }
}